import VideoDetectionCoordinate, { VideoDetectionPoint } from 'Models/Videos/Detections/VideoDetectionCoordinate';

export enum DetectionType {
	Logo,
	Text,
}

export interface EditorVideoDetection {
	id: number;
	trackId: number;
	brandId: number;
	placementId: number;
	detectionType: DetectionType;
	area: number;
	confidence: number;
	angle: number;
	perspective: number;
	initialCoordinates: VideoDetectionCoordinate;
	initialCenter: VideoDetectionPoint;
	manualDetection: boolean;
}

export default EditorVideoDetection;
